(function () {
  var sectionHeader = document.querySelector('.section-header');

  function getHeaderOffset() {
    if (!sectionHeader) return 0;
    var isSticky = sectionHeader.classList.contains('shopify-section-header-sticky');
    var isHidden = sectionHeader.classList.contains('shopify-section-header-hidden');
    if (isSticky && !isHidden) {
      return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
    }
    return 0;
  }

  function updateSelectorTops() {
    var offset = getHeaderOffset() + 'px';
    document.querySelectorAll('.ps-selector').forEach(function (sel) {
      sel.style.top = offset;
    });
  }

  if (sectionHeader) {
    new MutationObserver(updateSelectorTops).observe(sectionHeader, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function initProductStory(section) {
    var selector = section.querySelector('.ps-selector');
    if (!selector) return;

    selector.addEventListener('click', function (e) {
      var tab = e.target.closest('.ps-tab');
      if (!tab) return;

      var targetId = tab.dataset.target;
      var panel = section.querySelector('#' + targetId);
      if (!panel) return;

      section.querySelectorAll('.ps-tab').forEach(function (t) {
        t.classList.remove('is-active');
      });
      section.querySelectorAll('.ps-panel').forEach(function (p) {
        p.classList.remove('is-active');
      });

      tab.classList.add('is-active');
      panel.classList.add('is-active');

      var sectionTop = section.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: sectionTop - getHeaderOffset(), behavior: 'smooth' });
    });
  }

  document.querySelectorAll('.ps-section').forEach(initProductStory);
  updateSelectorTops();
})();
